import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './pagenotfound.component.html',
})
export class PageNotFoundComponent {
}
